import { observer } from 'mobx-react-lite';
import Box from '../../uikit/Box';
import Frame from '../../uikit/Frame';
import DocViewer from '../common/DocViewer';
import MetaHeader from '../MetaHeader';

const BlogTermsPage = observer(({ type }: { type: 'terms' | 'privacy' }) => {
    const title = type === 'terms' ? '이용약관' : '개인정보처리방침';

    return (
        <Frame>
            <MetaHeader title={title} />
            <Frame.Title title={title} />
            {type === 'terms' && (
                <>
                    <Box>
                        <DocViewer docKey={'terms-summary'} />
                    </Box>
                    <Box>
                        <DocViewer docKey={'terms'} />
                    </Box>
                </>
            )}
            {type === 'privacy' && (
                <>
                    <Box>
                        <DocViewer docKey={'privacy-summary'} />
                    </Box>
                    <Box>
                        <DocViewer docKey={'privacy'} />
                    </Box>
                </>
            )}
        </Frame>
    );
});

export default BlogTermsPage;
